import type { ApiErrorResponse, CreateDishResponse, DishCategory, WheelResponse } from "../shared/types";

export class ApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(response: ApiErrorResponse, status: number) {
    super(response.message);
    this.name = "ApiError";
    this.code = response.code;
    this.status = status;
  }
}

async function readResponse<T>(response: Response): Promise<T> {
  const data: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const fallback: ApiErrorResponse = { code: "REQUEST_FAILED", message: "网络开小差了，请稍后重试" };
    const detail = data && typeof data === "object" ? { ...fallback, ...(data as Partial<ApiErrorResponse>) } : fallback;
    throw new ApiError(detail as ApiErrorResponse, response.status);
  }
  return data as T;
}

export async function getWheel(slug: string): Promise<WheelResponse> {
  return readResponse<WheelResponse>(await fetch(`/api/wheels/${encodeURIComponent(slug)}`, {
    headers: { Accept: "application/json" },
    cache: "no-store",
  }));
}

export async function createDish(slug: string, name: string, category: DishCategory): Promise<CreateDishResponse> {
  return readResponse<CreateDishResponse>(await fetch(`/api/wheels/${encodeURIComponent(slug)}/dishes`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ name, category }),
  }));
}
